enum AccountType {
    InterestFree = 'InterestFree',
    Annuity = 'Annuity',
}

export default AccountType;
